import { isMobile } from "react-device-detect";
let setting = {
  dots: true,
  infinite: true,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  pauseOnHover: true,
};
export const SETTINGS_MULTI_ITEM = {
  ...setting,
  slidesToShow: isMobile ? 2 : 5,
  dots: false,
};
export const SETTINGS_FOUR_ITEM = {
  ...setting,
  slidesToShow: isMobile ? 1 : 4,
  arrows: false,
};
export const SETTINGS_THREE_ITEM = {
  ...setting,
  slidesToShow: isMobile ? 1 : 3,
  arrows: false,
};
export const SETTINGS_SINGLE_ITEM = {
  ...setting,
  arrows: true,
};
